/**
 * Questions Overview Page
 *
 * Shows a shortened location of each of the questions, for use in
 * grab and go style games. Allows users to skip around to particular questions.
 */
import React from 'react'
import LoggedInWrapper from '../../components/loggedinWrapper'
import QuestionSimple from '../../components/question/simple'
import Link from '../../components/link'
import { getTeamQuestionsMeta, getHuntStatus } from '../../utils/team-data'
import SvgArrow from '../../components/svg/arrow'
import { navigate } from '../../utils/navigate'
import AppContext from '../../utils/context'
import { getCurrentHuntData } from '../../utils/hunt-data'

export default class QuestionsOverviewPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      hunt_status: getHuntStatus(),
    }
  }
  componentDidMount() {
    if (this.state.hunt_status != `started`) {
      navigate(`/`)
    }
    const data = getCurrentHuntData()
    this.setState({ data: data })
    const question_meta = getTeamQuestionsMeta()
    this.setState(question_meta, () => {
      this.setLoading(false)
    })
  }

  render() {
    const { data, possible_points, score } = this.state

    return (
      <AppContext.Consumer>
        {({ setLoading }) => {
          this.setLoading = setLoading
          return (
            <LoggedInWrapper>
              <div className="site-sub-header px-4 py-2">
                <div className="row">
                  <div className="col-2 d-flex align-items-center">
                    <Link to={`/`} className={`back-arrow`}>
                      <SvgArrow className={`color-primary`} />
                    </Link>
                  </div>
                  <div className="col-10 text-right">
                    <h1 className={`d-inline-block title h5 smaller text-uppercase mb-0`}>
                      {data.hunt && data.hunt.questions_title ? data.hunt.questions_title : `Questions`}
                    </h1>
                    <span className="points title h5 smaller ml-2">
                      ({score}/{possible_points})
                    </span>
                  </div>
                </div>
              </div>
              {data.questions !== undefined && (
                <div
                  className={`mx-4 mt-4`}
                  style={{
                    paddingBottom: `60px`,
                  }}>
                  {data.questions !== undefined &&
                    data.questions.map((question, index) => (
                      <Link to={`/questions#${index + 1}`} key={question.id}>
                        <QuestionSimple
                          key={question.id}
                          q_num={index + 1}
                          total_q={data.questions.length}
                          question={question}
                          direction={question.directions_simple}
                        />
                      </Link>
                    ))}
                </div>
              )}
            </LoggedInWrapper>
          )
        }}
      </AppContext.Consumer>
    )
  }
}
